

import React, { useState, useEffect } from "react";
import "./Mice.css";
import { motion } from "framer-motion";
import MiceHighlights from "../Mice Vertical/MiceHighlight/MiceHighlights";
import EventText from "./EventsText";
import CTASection from "../CTASection/CTASection";
import bannerimg from "../../assets/Events/Mice-page/MICEsectionbanner.webp";
import HotelNetwork from "./HotelNetwork/HotelNetwork";
import EventGallery from "./EventGallery/EventGallery";

import Event from "../../assets/Events/Mice-page/mice event.JPG";
import Conference from "../../assets/Events/Mice-page/mice conference.JPG";
import mice from "../../assets/Events/Mice-page/mice trade.jpg";
import miceimg1 from "../../assets/Events/Mice-page/a (1).webp";
import miceimg2 from "../../assets/Events/Mice-page/a (2).webp";
import miceimg3 from "../../assets/Events/Mice-page/a (3).webp";
import miceimg4 from "../../assets/Events/Mice-page/a42.jpeg";
import miceimg5 from "../../assets/Events/Mice-page/a (5).webp";
import miceimg7 from "../../assets/Events/Mice-page/a (7).webp";
import miceimg9 from "../../assets/Events/Mice-page/a (9).webp";
import miceimg10 from "../../assets/Events/Mice-page/a (10).webp";
import miceimg11 from "../../assets/Events/Mice-page/a (11).webp";
import miceimg12 from "../../assets/Events/Mice-page/a (12).webp";
import miceimg13 from "../../assets/Events/Mice-page/a (13).webp";
import miceimg15 from "../../assets/Events/Mice-page/a (15).webp";
import miceimg16 from "../../assets/Events/Mice-page/a (16).webp";
import miceimg17 from "../../assets/Events/Mice-page/a (17).webp";
import miceimg18 from "../../assets/Events/Mice-page/a (18).webp";
import miceimg19 from "../../assets/Events/Mice-page/a (19).webp";
import miceimg20 from "../../assets/Events/Mice-page/a (20).webp";
import miceimg21 from "../../assets/Events/Mice-page/a (21).webp";
import miceimg22 from "../../assets/Events/Mice-page/a (22).webp";
import miceimg23 from "../../assets/Events/Mice-page/a (23).webp";
import miceimg24 from "../../assets/Events/Mice-page/a (24).webp";
import miceimg25 from "../../assets/Events/Mice-page/a (25).webp";
import miceimg26 from "../../assets/Events/Mice-page/a (26).webp";
import miceimg27 from "../../assets/Events/Mice-page/a (27).webp";
import miceimg28 from "../../assets/Events/Mice-page/a (28).webp";
import miceimg29 from "../../assets/Events/Mice-page/a (29).webp";
import miceimg30 from "../../assets/Events/Mice-page/a (30).webp";
import miceimg31 from "../../assets/Events/Mice-page/a (31).webp";
import miceimg32 from "../../assets/Events/Mice-page/a (32).webp";
import miceimg33 from "../../assets/Events/Mice-page/a (33).webp";
import miceimg34 from "../../assets/Events/Mice-page/a (34).webp";
import miceimg35 from "../../assets/Events/Mice-page/a (35).webp";
import miceimg36 from "../../assets/Events/Mice-page/a (36).webp";
import miceimg37 from "../../assets/Events/Mice-page/a (37).webp";
import miceimg38 from "../../assets/Events/Mice-page/a (38).webp";
import miceimg39 from "../../assets/Events/Mice-page/a (39).webp";
import miceimg40 from "../../assets/Events/Mice-page/a (40).webp";
import miceimg41 from "../../assets/Events/Mice-page/a (41).webp";
import miceimg42 from "../../assets/Events/Mice-page/b (1).jpeg";
import miceimg43 from "../../assets/Events/Mice-page/b (2).jpeg";
import miceimg44 from "../../assets/Events/Mice-page/b (3).jpeg";

const imagesPool = [miceimg1, miceimg2, miceimg3, miceimg4, miceimg5, miceimg7, miceimg9, miceimg10, miceimg11, miceimg12, miceimg13, miceimg15, miceimg16, miceimg17, miceimg18, miceimg19, miceimg20, miceimg21, miceimg22, miceimg23, miceimg24, miceimg25, miceimg26, miceimg27, miceimg28, miceimg29, miceimg30, miceimg31, miceimg32, miceimg33, miceimg34, miceimg35, miceimg36, miceimg37, miceimg38, miceimg39, miceimg40, miceimg41, miceimg42, miceimg43, miceimg44];

const getRandomImages = (pool, count = 6) => {
  const shuffled = [...pool].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, count);
};

function Mice() {
  const [randomImages, setRandomImages] = useState(() =>
    getRandomImages(imagesPool, 6)
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setRandomImages(getRandomImages(imagesPool, 6));
    }, 300000); // every 5 mins

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <div className="mice-container">
        <header
          className="mice-banner"
          style={{
            backgroundImage: `linear-gradient(rgba(0,0,0,0.2), rgba(0,0,0,0.2)), url(${bannerimg})`,
          }}
        >
          <EventText />
        </header>

        {/* Hero Section */}
        <section className="mice-content">
  <h1>
    MICE Event Management & Corporate Travel Solutions in India & Abroad | Event By ATLAS
  </h1>
  <p>
    Atlas Travel House specializes in end-to-end MICE (Meetings, Incentives, Conferences & Exhibitions) solutions, delivering seamless corporate event planning, incentive travel programs, conferences, and international exhibitions tailored to your business needs. Partner with us for flawless corporate travel and event experiences across India and global destinations.
  </p>
</section>

        {/* Main Content */}
        <main className="mice-content">
         <section>
  <h2>What is MICE?</h2>
  <p>
    MICE stands for <strong>Meetings, Incentives, Conferences & Exhibitions</strong>, a key sector in corporate tourism and business travel. 
    It involves organizing professional events such as corporate meetings, incentive trips, international conferences, and large-scale exhibitions designed to enhance networking, collaboration, and organizational growth. 
    From board meetings and corporate offsites to global conferences and trade shows, MICE services ensure every event is planned meticulously and executed flawlessly, delivering a seamless experience for attendees across India and worldwide.
  </p>
</section>





      <section>
  <h2>Why Choose Atlas Travel House for Corporate MICE Events?</h2>
  <p>
    Choosing the right partner for your corporate events and MICE (Meetings, Incentives, Conferences & Exhibitions) is critical to ensure flawless execution. 
    <strong>Atlas Travel House</strong> combines industry expertise with customized solutions to deliver high-impact MICE experiences across India and international destinations. 
    Leading businesses trust us for seamless planning, end-to-end event management, and exceptional corporate hospitality.
  </p>
  <ul>
    <li><strong>End-to-End Event Management:</strong> Comprehensive planning from concept to on-ground execution, ensuring smooth, error-free corporate events and incentive travel programs.</li>
    <li><strong>Premium Venues & Corporate Hospitality:</strong> Access to curated venues, luxury accommodations, and professional setups tailored to corporate standards.</li>
    <li><strong>Customized MICE Packages:</strong> Personalized travel and event solutions designed for your company’s objectives, team size, and budget.</li>
    <li><strong>Domestic & International Expertise:</strong> Proven success managing corporate events, conferences, offsites, and exhibitions across India and worldwide.</li>
    <li><strong>Advanced Event Technology:</strong> Cutting-edge tools for registration, attendee tracking, engagement, live streaming, and hybrid event integration.</li>
    <li><strong>Dedicated Relationship Manager:</strong> A single point of contact to coordinate logistics, provide timely updates, and ensure seamless execution of your corporate events.</li>
  </ul>
</section>

          <section>
  <h2>Our MICE Services: Corporate Event & Travel Solutions</h2>
  <p>
    Atlas Travel House offers a full range of MICE (Meetings, Incentives, Conferences & Exhibitions) services to streamline corporate travel and event planning. 
    Our expert team ensures seamless execution for every type of business event, from domestic meetings to international conferences and trade shows.
  </p>
  <ul>
    <li><strong>Corporate Meetings:</strong> Professional planning and execution of board meetings, strategy sessions, and corporate workshops with complete logistical support.</li>
    <li><strong>Incentive Travel:</strong> Tailored incentive trips designed to reward and motivate employees or clients, combining leisure, engagement, and business objectives.</li>
    <li><strong>Conferences & Seminars:</strong> Management of national and international conferences and seminars, including venue selection, technology support, and speaker assistance.</li>
    <li><strong>Exhibitions & Trade Shows:</strong> Comprehensive planning and execution of exhibitions and trade fairs, from booth design and setup to attendee management and on-ground coordination.</li>
  </ul>
</section>

        
        </main>
      </div>

    
       <MiceHighlights/> 
               <HotelNetwork />
                  <EventGallery/>

         <CTASection
            heading="Plan Your Next Corporate Event with Atlas Travel Houses"
            description="From offsites and conferences to large-scale exhibitions, our MICE experts ensure seamless planning, premium hospitality and flawless execution. Let us handle the details—so your team can focus on what truly matters."
            buttonText="Speak to Our MICE Expert"
            buttonLink="/contact"
          />

      {/* Random Gallery */}
          <div className="random-gallery">
             <h2 className="random-gallry-heading">Signature MICE Experiences</h2>
        <motion.div
          className="random-gallery-grid"
          initial={{ opacity: 0, y: 100 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: false }}
        >
          {randomImages.map((img, idx) => (
            <motion.div
              className="random-img-wrapper"
              key={idx}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: idx * 0.1 }}
              viewport={{ once: true }}
            >
              <img src={img} alt={`MICE Event Image ${idx + 1}`} />
            </motion.div>
          ))}
        </motion.div>
      </div>
    </>
  );
}

export default Mice;